module.exports = __webpack_public_path__ + "media/alertaPanico.1d6fa3f5.mp3";